var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-toolbar',_vm._g(_vm._b({staticClass:"binds-app-toolbar",class:_vm.toolbarClasses,style:(_vm.toolbarStyles)},'binds-toolbar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }